// SPDX-License-Identifier: MIT
// Singleton cache for the last anthropic-ratelimit-* headers seen from an
// edge-fn response. Updated by callers of magnify/discover/converse on the web;
// read by the web UsageBridge via lastWebUsageEvent().
import { parseUsageFromHeaders } from './usage-stream-tap';
import type { UsageEvent } from './usage-types';

let last: Record<string, string> | null = null;

export function rememberRateLimitHeaders(h: Record<string, string>): void {
  last = h;
}

export function lastWebUsageEvent(): UsageEvent | null {
  return last ? parseUsageFromHeaders(last) : null;
}

/** Test seam: sets the singleton to true null (not an empty-map stand-in). */
export function _resetLastForTesting(): void { last = null; }
